import { FilterActionTypes } from '@app/pcs/actions/filter';
import { LabelActionTypes } from '@app/pcs/actions/label';
import { RecentActivityActions, RecentActivityActionTypes } from '@app/pcs/actions/recent-activity';
import { QuickSearchActionTypes } from '@app/pcs/dashboard/actions/quick-search';
import { DossierSearchKey } from '@app/pcs/models';
import { isDossierNavigationAction } from '@app/pcs/util';
import { BackButtonActionTypes } from '@dossier/actions/back-button';
import { Action } from '@ngrx/store';
import { createHandler, createReducer, persistReducer } from '@util';
import * as R from 'ramda';

export interface State {
  recentActivity: boolean;
}

export const initialState: State = {
  recentActivity: true
};

// Selectors
type GetRecentActivitySelected = (s: State) => boolean;
export const getRecentActivitySelected: GetRecentActivitySelected = R.prop('recentActivity');

// Handlers
const deselectRecentActivity = (state: State): State =>
  R.mergeRight(state, {
    recentActivity: false
  });

const selectRecentActivity = (state: State): State =>
  R.mergeRight(state, {
    recentActivity: true
  });

const selectRecentActivityHandler = createHandler(RecentActivityActionTypes.SelectRecentActivity, selectRecentActivity);
const deselectHandler = createHandler([
  FilterActionTypes.SelectFilter,
  QuickSearchActionTypes.SetSearchTerm,
  LabelActionTypes.SelectLabel
],
deselectRecentActivity
);

const recentActivityReducer = createReducer<State, RecentActivityActions>([
  selectRecentActivityHandler,
  deselectHandler
], initialState);

export const reducer = persistReducer<State, State>(
  {
    storageKey: DossierSearchKey.RecentActivity,
    shouldSync: (_, action: Action): boolean => isDossierNavigationAction(action),
    shouldReinitialize: (_, action: Action): boolean => action.type === BackButtonActionTypes.GoBack
  },
  recentActivityReducer
);
